<template><v-expansion-panels v-model="panelState">
    <v-expansion-panel>
        <v-expansion-panel-header>
            <h5 class="column-title-heading">
                Slingshot Digital Access Code
            </h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div class="slingshot-access-code">
                <v-text-field
                    v-model="localDuration"
                    label="Duration (Days)"
                    outlined
                    dense
                    type="number"
                    :error-messages="computedErrorMessages"
                    :required="hasSlingshotDesignator"
                />
                <v-textarea
                    :value="instructions"
                    label="Instructions"
                    outlined
                    dense
                    rows="3"
                    @input="$emit('update:instructions', $event)"
                />
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
export default {
    name: 'SlingshotAccessCode',
    props: {
        hasSlingshotDesignator: {
            type: Boolean,
            required: true,
        },
        duration: {
            type: Number,
            default: null,
        },
        instructions: {
            type: String,
            default: null,
        },
        durationError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            panelState: undefined,
            localDuration: this.duration,
        };
    },
    computed: {
        computedErrorMessages() {
            const msgs = [];

            // Required only if designator selected
            if (this.hasSlingshotDesignator && (this.localDuration === null || this.localDuration === '' || this.localDuration === 0)) {
                msgs.push('Duration is required');
            }

            // Whole number / -1 check always
            if (this.localDuration !== null && this.localDuration !== '') {
                if (!Number.isInteger(this.localDuration)) msgs.push('Duration must be a whole number or -1');
                if (this.localDuration < -1) msgs.push('Duration cannot be less than -1');
            }

            return msgs;
        },
    },
    watch: {
        hasSlingshotDesignator: {
            immediate: true,
            handler(newVal) {
                this.panelState = newVal ? 0 : null;
            },
        },
        duration(newVal) {
            this.localDuration = newVal;
        },
        localDuration(newVal) {
            this.$emit('update:duration', newVal !== '' && newVal !== null ? Number(newVal) : null);
        },
    },
};
</script>

<style lang="scss" scoped>
.slingshot-access-code {
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
